import { render, staticRenderFns } from "./SupplierMakes.vue?vue&type=template&id=306cd8d6"
import script from "./SupplierMakes.vue?vue&type=script&lang=js"
export * from "./SupplierMakes.vue?vue&type=script&lang=js"
import style0 from "./SupplierMakes.vue?vue&type=style&index=0&id=306cd8d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports